<template>
  <div>
    <v-row>
      <v-col cols="2">
        <div class="preview">
          <v-img
            v-if="image"
            :src="image"
            width="100%"
            contain
          />
          <v-img
            v-else-if="modelValue"
            :src="modelValue"
            width="100%"
            contain
          />
          <v-btn
            v-if="modelValue"
            class="delete-button"
            small
            color="error"
            elevation="0"
            @click.prevent="deleteImage"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="10">
        <v-row>
          <v-col cols="12">
            <v-file-input
              :label="label"
              accept="image/*"
              @change="startImageCropping($event)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog
      v-model="showCropper"
      max-width="800"
    >
      <v-card>
        <v-card-title
          class="text-h5 grey lighten-2"
          primary-title
        >
          Cortar imagem
        </v-card-title>
        <v-card-text>
          <cropper
            :ref="cropperId"
            :src="croppingImage"
            :stencil-props="{aspectRatio: cropAspectRatio ? cropAspectRatio : null}"
            :canvas="{width: outputWidth ? outputWidth : null, quality: 100, maxWidth: maxOutputWidth ? maxOutputWidth : null}"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click.prevent="setImage(croppingImage)"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { Cropper } from 'vue-advanced-cropper'
  import resizeImage from '@/helpers/imageResizeHelper'

  export default {
    name: 'SimpleImageUploader',
    components: {
      Cropper,
    },
    props: {
      value: {
        type: String,
        required: false,
      },
      label: {
        type: String,
        default: 'Conteúdo',
      },
      error: {
        type: String,
        required: false,
      },
      cropAspectRatio: {
        type: Number,
        required: false,
      },
      outputWidth: {
        type: Number,
        required: false,
      },
      maxOutputWidth: {
        type: Number,
        required: false,
      },
    },
    emits: ['input'],
    data: function () {
      return {
        cropperId: 'cropper-' + Math.random().toString(36).substring(7),
        modelValue: null,
        content: this.value,
        showCropper: false,
        croppingImage: null,
        image: null,
      }
    },
    watch: {
      content: function (value) {
        this.$emit('input', value)
      },
      modelValue: function (value) {
        this.content = value
      },
    },
    mounted: function () {
      this.modelValue = this.value
      this.image = this.value
    },
    methods: {
      startImageCropping: function (file) {
        const self = this

        if (file) {
          const reader = new FileReader()
          reader.onload = async (e) => {
            const totalMb = e.total / 1000000
            if (totalMb > 10) {
              self.error = 'A imagem não pode ter mais de 10MB. Escolha uma imagem menor.'
              self.showErrorDialog = true
              return
            }
            self.image = await resizeImage(e.target.result)
            self.openCropper(self.image)
          }
          reader.readAsDataURL(file)
        }
      },

      openCropper: function (photo) {
        const self = this

        self.showCropper = true
        self.croppingImage = photo
      },

      setImage: function () {
        this.showCropper = false
        const { canvas } = this.$refs[this.cropperId].getResult()
        const result = canvas.toDataURL('image/webp', 90)
        this.image = result
        this.modelValue = result
        this.updateValue()
      },

      updateValue: function () {
        this.$emit('input', this.modelValue)
      },

      deleteImage: function () {
        this.modelValue = null
        this.image = null

        this.updateValue()
      },
    },
  }
</script>

<style>
.preview {
  position: relative;
}

.delete-button {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
